import React from 'react';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

import { AntdConfigProvider } from '@/contexts/AntdConfigProvider/AntdConfigProvider';
import { AuthContextProvider } from '@/contexts/Auth/AuthContext';
import { FeatureProvider } from '@/contexts/Features/FeatureProvider';
import { ModalContextProvider } from '@/contexts/Modal/ModalContext';
import { ServicesProvider } from '@/contexts/Services/ServicesContext';

import { queryClient, persister, persistOptions } from '@/lib/queryClient';

const RootLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister, ...persistOptions }}>
      <AntdConfigProvider>
        <AuthContextProvider>
          <ServicesProvider>
            <ModalContextProvider>
              <FeatureProvider>{children}</FeatureProvider>
            </ModalContextProvider>
          </ServicesProvider>
        </AuthContextProvider>
      </AntdConfigProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  );
};

export default RootLayout;
